const AltLogo = () => {
  return (
    <span style={{ fontWeight: '900', fontSize: '16px', color: '#000', fontFamily: 'Montserrat' }}>DigitalTrendingLab</span>
  )
}

export { AltLogo }
